export type AddPrePayResponse = {
  orderId: number;
  hash: string;
  link: string;
};

export type PrePayEntitlement = {
  /** The provider's `lookup_key` - the stable identifier to branch on. */
  key: string;
  /** Display name as typed in the provider dashboard; may be absent. */
  name: string | null;
  /** What granted it, as a kind rather than an id - see `EntitlementSource`. */
  source: string;
  /** The entitlement's own metadata, passed through uninterpreted. */
  values: Record<string, string>;
};

export const EntitlementSource = {
  SUBSCRIPTION: 'subscription'
};

/** Raw wire shape of `GET {PAYMENT_API}/prepay`. */
export type GetPrePayApiBalanceResponse = {
  balance: number;
  currency: string;
  websiteId: number;
  minimumTopUp: number;
  freeThreshold: number;
  freePercentage: number;
  freePercentageEntitlement?: PrePayEntitlement;
  balances: { [currencyCode: string]: number };
};

/** App-facing prepay balance, in major currency units. */
export interface GetPrePayBalanceResponse {
  balance: number;
  currencyCode: string;
  freePrePayMinimumSpend?: number;
  freePrePayPercentage?: number;
  prePayMinimumTopUp: number;
  isBoostedBySubscription: boolean;
  showOffer: boolean;
}
